// Let a tall product panel scroll to its bottom before it sticks. CSS keeps it
// within the gallery's grid row, so both columns leave together at the end.
const productScrollControllers = new Map();

function initializeProductScroll(root) {
  if (productScrollControllers.has(root)) return;
  const panel = root.querySelector('.clr-product-panel');
  if (!panel) return;

  const desktop = window.matchMedia('(min-width: 901px)');
  let frame = 0;

  const update = () => {
    frame = 0;
    if (!desktop.matches) {
      root.removeAttribute('data-clr-bottom-sticky');
      panel.style.removeProperty('--clr-product-sticky-top');
      return;
    }

    const gap = 16;
    const viewportHeight = document.documentElement.clientHeight;
    const panelHeight = panel.getBoundingClientRect().height;
    const top = Math.min(gap, viewportHeight - panelHeight - gap);
    panel.style.setProperty('--clr-product-sticky-top', `${top}px`);
    root.setAttribute('data-clr-bottom-sticky', '');
  };

  const scheduleUpdate = () => {
    if (!frame) frame = window.requestAnimationFrame(update);
  };

  // Accordions, variant messages, web fonts and product-option apps can all
  // change the panel height after the page loads.
  const observer = new ResizeObserver(scheduleUpdate);
  observer.observe(panel);
  window.addEventListener('resize', scheduleUpdate);
  desktop.addEventListener('change', scheduleUpdate);
  update();

  productScrollControllers.set(root, () => {
    observer.disconnect();
    window.cancelAnimationFrame(frame);
    window.removeEventListener('resize', scheduleUpdate);
    desktop.removeEventListener('change', scheduleUpdate);
    root.removeAttribute('data-clr-bottom-sticky');
    panel.style.removeProperty('--clr-product-sticky-top');
    productScrollControllers.delete(root);
  });
}

document.querySelectorAll('[data-clr-product]').forEach(initializeProductScroll);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-clr-product]').forEach(initializeProductScroll);
});
document.addEventListener('shopify:section:unload', (event) => {
  for (const [root, destroy] of productScrollControllers) {
    if (event.target.contains(root)) destroy();
  }
});
